import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { CompanyGameListing } from "../../modules/companyGame/component/CompanyGameListing";
import Dashboard from "../../modules/dashboard/components/Dashboard";

const DashboardContext = createContext();

const DashbordWrapper = () => {
  const value = {};

  return (
    <DashboardContext.Provider value={value}>
      <Routes>
        <Route path="" element={<Dashboard />} />
        <Route path="companyGame" element={<CompanyGameListing />} />
      </Routes>
    </DashboardContext.Provider>
  );
};

export { DashbordWrapper };
